import axios from 'axios';
import API_URL from '../config';

function getAuthHeader() {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * Generic API request helper.
 * @param {string} path - API path (e.g. '/campaigns')
 * @param {object} [options] - { method, body, headers }
 * @returns {Promise<any>} response data
 */
export async function apiRequest(path, options = {}) {
  const { method = 'GET', body, headers = {} } = options;
  const url = `${API_URL}/api${path}`;

  const config = {
    method,
    url,
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  if (body) {
    config.data = typeof body === 'string' ? JSON.parse(body) : body;
  }

  const res = await axios(config);
  return res.data;
}
